import { render, staticRenderFns } from "./ZDMFailureStatusDictionaryList.vue?vue&type=template&id=6a58a475&scoped=true&"
import script from "./ZDMFailureStatusDictionaryList.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureStatusDictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./ZDMFailureStatusDictionaryList.vue?vue&type=style&index=0&id=6a58a475&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58a475",
  null
  
)

export default component.exports